import { Component, ElementRef, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { fromEvent, noop } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-custom-search-input',
  templateUrl: './custom-search-input.component.html',
  styleUrls: ['./custom-search-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => CustomSearchInputComponent),
    }
  ]
})
export class CustomSearchInputComponent implements ControlValueAccessor {

  @Input() placeholder: string;
  @Input() delay: number = 300;
  @Input() inputValue: string;
  @Input() readonly: boolean = false;
  @Input() success: boolean = false;
  @Input() fail: boolean = false;
  @Input() name: string;
  @Input() small: boolean = false;
  @Input() tabindex: number;
  @Input() blue: boolean = true;
  @Input() hasResults: boolean = false;
  @Input() showLoading: boolean = false;
  @Output() outValue = new EventEmitter<string>(null);
  @Output() focusLost = new EventEmitter<boolean>();
  @Output() focusGained = new EventEmitter<boolean>();

  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  constructor(private elementRef: ElementRef) {
    const eventStream = fromEvent(elementRef.nativeElement, 'keyup')
      .pipe(
        map(() => this.inputValue),
        debounceTime(this.delay),
        distinctUntilChanged()
      );

    eventStream.subscribe((input) => {
      this.outValue.emit(input);
    });
  }

  //get accessor
  get value(): any {
    return this.inputValue;
  }

  //set accessor including call the onchange callback
  set value(v: any) {
    this.inputValue = v;
    this.onChangeCallback(v);
  }

  onBlurEvent(event: any) {
    this.focusLost.emit(true);
  }

  focusGainedEvent(event: any) {
    this.focusGained.emit(true);
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    // Unused
  }

  writeValue(obj: any): void {
    this.inputValue = obj;
  }

}
